import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';

export interface InfoDialogConfig {
  title: string;
  messageTitle?: string;
  message: string;
  icon?: string;
  iconColor?: string;
  buttonLabel?: string;
  buttonIcon?: string;
  closable?: boolean;
  width?: string;
  maxWidth?: string;
  minWidth?: string;
}

@Component({
  selector: 'app-info-dialog',
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule],
  templateUrl: './info-dialog.component.html',
  styleUrls: ['./info-dialog.component.scss']
})
export class InfoDialogComponent {
  private _visible: boolean = false;

  @Input() 
  get visible(): boolean {
    return this._visible;
  }
  set visible(value: boolean) {
    this._visible = value;
    this.visibleChange.emit(value);
  }

  @Output() visibleChange = new EventEmitter<boolean>();
  @Input() config: InfoDialogConfig = {
    title: 'Informação',
    messageTitle: '',
    message: '',
    icon: 'pi pi-info-circle',
    iconColor: '#2196F3',
    buttonLabel: 'OK',
    buttonIcon: 'pi pi-check',
    closable: false,
    width: '50vw',
    maxWidth: '500px',
    minWidth: '300px'
  };
  @Output() onClose = new EventEmitter<void>();

  get dialogStyle(): any {
    return {
      width: this.config.width || '50vw',
      'max-width': this.config.maxWidth || '500px',
      'min-width': this.config.minWidth || '300px'
    };
  }

  get iconStyle(): any {
    return {
      'font-size': '2rem',
      color: this.config.iconColor || '#2196F3',
      'margin-right': '1rem'
    };
  }

  closeDialog(): void {
    this._visible = false;
    this.visibleChange.emit(false);
    this.onClose.emit();
  }
}

